import React, { Component } from 'react';

// Modules
import ContentLoader from 'react-content-loader';

class ForumsSkeletonTopicsScreen extends Component {  
  constructor() {
    super();
    this.state = {
      backgroundColor: '#f3f3f3',
      foregroundColor: '#ecebeb',
    };
  }

  renderDefaultItems = (itemClassList) => {

    let items = [];
    let numberOfItems;

    if (this.props.numberOfItems) {
      numberOfItems = this.props.numberOfItems;
    } else {
      numberOfItems = 20;
    }

    for (let i = 0; i < numberOfItems; i++) {

      items.push(
        <div key={'item-' + i} className={itemClassList} style={{paddingBottom: 0, border: 'none'}}>
          <ContentLoader 
            speed={2}
            width={'100%'}
            height={'100%'}
            viewBox="0 0 1140 79"
            backgroundColor={this.state.backgroundColor}
            foregroundColor={this.state.foregroundColor}
          >
            <rect x="877.826" y="49.427" width="131.796" height="20" rx="10" ry="10" />
            <rect x="877.826" y="22.328" width="111.9" height="20" rx="10" ry="10" />
            <rect x="780.329" y="22.328" width="20" height="20" rx="10" ry="10" />
            <rect x="585.363" y="22.328" width="112.248" height="20" rx="10" ry="10" />
            <rect x="30.698" y="22.328" width="354.394" height="20" rx="10" ry="10" />
            <rect x="0" y="23.578" width="17.473" height="17.5" rx="5" ry="5" />
          </ContentLoader>
        </div>
      );

    }

    return items;
  };

  render() {
    const itemClass = "forum-topic";
    const itemClassList = `${itemClass}  item`;

    return (
      <main className="forums-topics  screen">
        <div className="page-header">
          <ContentLoader 
            speed={2}
            width={'100%'}
            height={'100%'}
            viewBox="0 0 1140 50"
            backgroundColor={this.state.backgroundColor}
            foregroundColor={this.state.foregroundColor}
          >
            <rect x="-0" y="0" width="585.363" height="50" rx="10" ry="10" />
          </ContentLoader>
        </div>

        <div className="forums-board-description">
          <ContentLoader 
            speed={2}
            width={'100%'}
            height={'100%'}
            viewBox="0 0 1140 20"
            backgroundColor={this.state.backgroundColor}
            foregroundColor={this.state.foregroundColor}
          >
            <rect x="0" y="0" width="826.47" height="20" rx="10" ry="10" />
          </ContentLoader>
        </div>

        {/* Table headings */}
        <ContentLoader 
          speed={2}
          width={'100%'}
          height={'100%'}
          viewBox="0 0 1140 15"
          backgroundColor={this.state.backgroundColor}
          foregroundColor={this.state.foregroundColor}
        >
          <rect x="585.363" y="0" width="46.992" height="15" rx="7.5" ry="7.5" />
          <rect x="780.329" y="0" width="38.754" height="15" rx="7.5" ry="7.5" />
          <rect x="877.826" y="0" width="62.419" height="15" rx="7.5" ry="7.5" />
          <rect x="-0" y="0" width="33.769" height="15" rx="7.5" ry="7.5" />
        </ContentLoader>

        {this.renderDefaultItems(itemClassList)}
      </main>
    );
  }

}

export default ForumsSkeletonTopicsScreen;